export default {
  // js/components/Orders/index.vue

  Pedidos: "Pedidos",

  "Você não possui nenhuma integração": "No tienes integración",
  "Clique aqui": "Haga clic aquí",
  "para configurar": "para configurar",
  "ID do canal": " ID del canal",
  "SKU do pedido": "SKU del pedido",
  "Status:": "Estatus:",
  "Seleciona o status...": "Seleccione el estatus...",
  "Data:": "Fecha:",
  "Por conta:": "Por Cuenta:",
  "Seleciona o status": "Seleccione el estatus",
  "Por cliente:": "Por Cliente:",
  "Primeiro nome": "Nombre",
  Sobrenome: "Apelido",
  Canal: "Canal",
  "Seleciona o canal": "Seleccione el canal",
  "Limpar filtros": "Borrar filtros",
  Filtrar: "Filtrar",
  Todos: "Todos",
  "Para Faturar": "Para Factura",
  "Para Enviar": "Para Enviar",
  "Erro no Envio": "Error en el envío",
  "Você não tem permissão para ver os pedidos.":
    "Usted no tiene permiso para ver los pedidos.",
  Pendente: "Pendiente",
  Pago: "Pago",
  Aprovado: "Aprobado",
  "Pagamento parcial": "Pago parcial",
  "Entrega informada": "Entrega informada",
  "Nota fiscal solicitada": "Nota fiscal solicitada",
  Faturado: "Facturado",
  "Erro ao gerar nota fiscal": "Error al generar nota fiscal",
  "Entrega aceita": "Entrega aceptada",
  "Erro ao enviar entrega": "Error al enviar entrega",
  Entregue: "Entregado",
  Cancelado: "Cancelado",
  "Sob análise": "Bajo análisis",
  "Envio expirado": "Envío caducado",
  "Entrega expirada": "Entrega caducada",
  "Enviar Hoje": "Enviar hoy",
  "Informado por": "Informado por",
  "Estejam integrados": "Están integrados",
  "Não estejam integrados": "No están integrados",
  "Não foi possivel buscar os pedidos com erro de integração, tente novamente em alguns instantes.":
    "No fue posible buscar los pedidos con error de integración, inténtelo de nuevo en unos instantes.",
  "Não consegui carregar suas preferências, por favor recarregue a página.":
    "No puedes cargar tus preferencias, por favor recargue la página.",
  "Não foi possivel buscar suas contas, por favor atualize a pagina.":
    "No fue posible buscar sus cuentas, por favor actualiza la pagina",
  "Não existem mais pedidos para serem exibidos.":
    "No hay más pedidos para mostrarse.",
  "Ocorreu algum problema ao buscar seus pedidos, <b>atualize a pagina</b> e tente novamente.":
    "Hubo algún problema al buscar sus pedidos, <b>actualice la página</b> e inténtelo de nuevo.",
  "Não conseguimos encontrar nada com o filtro utilizado.":
    "No hemos encontrado nada con el filtro utilizado.",

  // js/components/Orders/OrdersList

  "Data de criação": "Fecha Creación",
  "Nome completo": "Nombre Completo",
  Status: "Estatus",
  Total: "Totale",
  Ações: "Acciones",

  // js/components/Orders/OrdersAction

  Exportação: "Exportación",
  Notificações: "Notificaciones",
  "Exportar pedidos": "Exportar pedidos",
  "Exportar modelo de planilha para entrega":
    "Exportar plantilla de hoja de cálculo para entrega",
  "Alterar status para entregue (status final)":
    "Cambio de estado para entrega (estado final)",
  "Alterar status para cancelado (status final)":
    "Cambio de estado a cancelado (estado final)",
  "Reenviar notificações": "Reenviar notificaciones",
  "Importar planilha de entregas em massa":
    "Importar hoja de trabajo de entrega masiva",
  Selecione: "Seleccione",
  Importar: "Importar",
  "Exportação de pedidos": "Exportación de pedidos",
  "Todos os seus pedidos serão exportados para uma planilha excel e esta planilha será enviada para você assim que este processo estiver concluído.":
    "Todos sus pedidos se exportarán a una hoja de cálculo de Excel y esta hoja de trabajo se enviará a usted tan pronto como este proceso se ha completado.",
  "Dependendo da quantidade de pedidos que você tiver este processo pode demorar, por este motivo pedimos que você insira para qual e-mail deseja que a planilha seja enviada assim que a exportação for concluída:":
    "Dependiendo de la cantidad de pedidos que tenga este proceso puede tardar, por lo que le pedimos que introduzca para qué correo desea que la hoja de trabajo se envíe una vez finalizada la exportación:",
  "Exportar apenas pedidos filtrados": "Exportar sólo pedidos filtrados",
  "Exportar como XLSX": "Exportar como XLSX",
  "Exportar como PDF": "Exportar como PDF",
  "meu@email.com.br": "mi@email.com.br",
  "Não foi possivel realizar a exportação do pedido, tente novamente em alguns instantes.":
    "No fue posible realizar la exportación del pedido, inténtelo de nuevo en unos instantes.",
  "Pronto!": "Listo!",
  "Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!": "¡Pedidos exportados con éxito!",
  "Não foi possivel exportar os pedidos.":
    "No fue posible exportar los pedidos.",
  "Seu arquivo já foi incluido para importação, em breve você podera vê-lo em seu painel.":
    "Su archivo ya ha sido incluido para la importación, pronto usted podrá verlo en su panel.",
  "Não foi possivel processar seu arquivo, tente novamente em alguns instantes.":
    "No se pudo procesar el archivo, vuelva a intentarlo en unos instantes.",
  "Você selecionou os pedidos para aplicar esta ação?":
    "¿Ha seleccionado los pedidos para aplicar esta acción?",
  "Não foi possivel reenviar as notificações dos pedidos com ID: ${ids}, tente novamente em alguns instantes.":
    "No se pudo reenviar las notificaciones de los pedidos con ID: ${ids}, vuelva a intentarlo en unos instantes.",
  "Os status dos pedidos foram alterados com sucesso!":
    "¡El estado de los pedidos ha cambiado con éxito!",
  "Não foi possivel reenviar a notificação para os pedidos selecionados, tente novamente em alguns instantes.":
    "No se pudo reenviar la notificación a los pedidos seleccionados, vuelva a intentarlo en unos instantes.",
  "O reenvio da notificação foi enviado com sucesso!":
    "Lo reenvío de la notificación se envió con éxito!",

  //novos
  // js/components/Orders/ShowOrder.vue
  "Status do pedido": "Status do pedido",
  "Data da compra": "Data da compra",
  Voltar: "Voltar",
  "Salvar alterações": "Salvar alterações",
  "Exportar PDF": "Exportar PDF",
  "Status (final)": "Status (final)",
  "Marcar como entregue": "Marcar como entregue",
  "Marcar como cancelado": "Marcar como cancelado",
  "Dados Faturamento": "Dados Faturamento",
  Nome: "Nome",
  CPF: "CPF",
  CNPJ: "CNPJ",
  Telefone: "Telefone",
  País: "País",
  "Dados Entrega": "Dados Entrega",
  "Ver Endereço": "Ver Endereço",
  "Ver Dados de Entrega": "Ver Dados de Entrega",
  Endereço: "Endereço",
  Nº: "Nº",
  Bairro: "Bairro",
  Cidade: "Cidade",
  Estado: "Estado",
  País: "País",
  CEP: "CEP",
  "Criar nova entrega": "Criar nova entrega",
  "Adicionar novo": "Adicionar novo",
  "Dados Adicionais": "Dados Adicionais",
  "Tipo de Entrega": "Tipo de Entrega",
  "Plugg ID": "Plugg ID",
  Totais: "Totais",
  Subtotal: "Subtotal",
  Frete: "Frete",
  "Total Pago": "Total Pago",
  "Histórico de Status": "Histórico de Status",
  "Aplicação que realizou esta ação": "Aplicação que realizou esta ação",
  "Não encontramos atualizações de status para este pedido.":
    "Não encontramos atualizações de status para este pedido.",
  "Logs do Pedido": "Logs do Pedido",
  "Não encontramos nenhum log nesse pedido":
    "Não encontramos nenhum log nesse pedido",
  Editar: "Editar",
  Pagamentos: "Pagamentos",
  "Não encontramos pagamentos para este pedido.":
    "Não encontramos pagamentos para este pedido.",
  Método: "Método",
  Tipo: "Tipo",
  Parcela: "Parcela",

  // js/components/Orders/ShowOrder.vue
  "Sem informação": "Sem informação",
  Preço: "Preço",
  Quantidade: "Quantidade",
  Desconto: "Desconto",
  Comissão: "Comissão",
  "Imposto": "Imposto",
  "Adicionar novo item ao pedido": "Adicionar novo item ao pedido",
  "SKU do produto": "SKU do produto",
  "Lembre-se: o": "Lembre-se: o",
  "deve ser único": "Lembre-se: o", //contexto - Lembre-se: o SKU deve ser único.
  "Preço ex: 29.99": "Preço ex: 29.99",
  "Data estimada de envio": "Data estimada de envio",
  "Data estimada de entrega": "Data estimada de entrega",

  //index.vue
  "Fim dos pedidos": "Fim dos pedidos",
  Novo: "Novo",

  // js/components/Orders/ShowShipments.vue
  Entrega: "Entrega",
  "Não definido": "Não definido",
  Transportadora: "Transportadora",
  "Nome da transportadora": "Nome da transportadora",
  "Método de entrega": "Método de entrega",
  "Código de rastreio": "Código de rastreio",
  "URL de rastreio": "URL de rastreio",
  "Data estimada (entrega)": "Data estimada (entrega)",
  "Data de despacho": "Data de despacho",
  "Data da nota fiscal": "Data da nota fiscal",
  "Número da Nota Fiscal": "Número da Nota Fiscal",
  "Chave da Nota Fiscal": "Chave da Nota Fiscal",
  "Consulta da Nota Fiscal": "Consulta da Nota Fiscal",
  "URL de consulta da nota fiscal": "URL de consulta da nota fiscal",
  "Série da Nota Fiscal": "Série da Nota Fiscal",
  Cancelar: "Cancelar",
  "Salvar informações": "Salvar informações",

  pending: "Pendente",
  paid: "Pago",
  approved: "Aprovado",
  partial_payment: "Pagamento parcial",
  shipping_informed: "Entrega informada",
  waiting_invoice: "Nota fiscal solicitada",
  invoiced: "Faturado",
  invoice_error: "Erro ao gerar nota fiscal",
  shipping_error: "Despacho incorreto",
  delivered: "Entregue",
  canceled: "Cancelado",
  under_review: "Sob análise",
  expiredSendSla: "Envio expirado",
  expiredDeliverySla: "Entrega expirada",
  sendToday: "Enviar Hoje",

  //index.vue
  "Fim dos pedidos": "Fim dos pedidos",
  Novo: "Novo",
  "Nenhum pedido encontrado": "Nenhum pedido encontrado",

  pending: "Pendente",
  paid: "Pago",
  approved: "Aprovado",
  partial_payment: "Pagamento parcial",
  shipping_informed: "Entrega informada",
  waiting_invoice: "Nota fiscal solicitada",
  invoiced: "Faturado",
  invoice_error: "Erro ao gerar nota fiscal",
  shipping_error: "Despacho incorreto",
  delivered: "Entregue",
  canceled: "Cancelado",
  under_review: "Sob análise",
  expiredSendSla: "Envio expirado",
  expiredDeliverySla: "Entrega expirada",
  sendToday: "Enviar Hoje",
  f470a016e1ffd4e815ec068389483d05: "Abx Climatização",
  "06fbad3480cf83d439cc271e86eaa82b": "Amazon",
  c44d12a2fd31dc5b9c35f94fc69f8d9b: "Antes de Mim",
  "041c45aceeecf5bc1ec173012ceb2dae": "B2W",
  "6bd10e36e53ed4466d477c6b275c397b": "B2W V2",
  c65017d475d2a585956dbc4f7d66173c: "Bling",
  de5b3c616d7ba2191eaf10441c29ad54: "Buscapé",
  "048e9f2efcf6659867648b43c2b7a7ca": "C&amp;A",
  "7c0d4545e312d0c732807c7b8ab25fdd": "Carrefour",
  "76b6a6897c736f4047c7099a8a7ff210": "Catálogo",
  c0972e1d1e2ed46ba76639e52f931b37: "Centauro",
  a106d72f997e5d3c8a08ce5c32e849b7: "CiaShop - Integração",
  adcb048802cc420eeba779cf5a084243: "Cnovav2",
  "117db8ea06eca0f5af5602e9939ce601": "Correios",
  c8519513bcc4bad2df82f931e7292248: "Dafiti",
  ec2fa4717215a865fa804cb71066b660: "Eskolare",
  "1b4cfd70c334154d816ee83d4fae986a": "Fotter",
  "1169c8db2365e89fa8fc25cbff611908": "Frete Planilha",
  d5260419e36a720e451b71e79d5f5d0b: "Importador de Fotos",
  f2638deaba9395e9ff728385530cab8b: "Intelipost",
  "9f2c96d28e70e03e23ff0ae35e770db7": "KPL (Ábacos) ERP",
  d7363d1e13afc21e308e3ec62e882cb0: "Leitor de XML",
  f3f0b1de6fe197aaccf5c198c2496e12: "Loja Integrada ",
  "9e5e25b65aba5508dce1697c084ce7a2": "Madeira Madeira",
  "7de4f283401c91fee5a86e9f6a56ae98": "Magazine Luiza",
  db88c2ffe78f0992c1d7d7371f58ca47: "MercadoLivre",
  "81498500a3fea85ca24c3a9a1313f867": "MercadoLivreDev",
  "373bd948d42e6923b97e67d0ce1aa4ad": "Millenium ERP",
  "3bc5b02d367af07061257df2316d1707": "Mobly",
  "1522c5fb1ec6d49d43cae528bfb8f3cd": "Multiplus",
  "1e1f6881d288028104c74aa87910452b": "MyMarketplace",
  aaf2eff2c5c8cdb0fb7becfddb57d7dd: "Netshoes",
  "33fa51547c27e4d751816b2707d8de76": "OpenCart API",
  "2aac763e61756161c1252ec8ded8a52d": "OPTE+",
  "9d510fbf530d324509298323e9029efd": "Outlet do Músico",
  "6e19e8b91aa41d1911cf24ef4ae265e7": "Pedidos",
  "5c3bb167c1d19e8b6cb1f5b67ae75d0a": "Precificação",
  e522d2e88e08dd7e276b968e7e7a1c57: "Produtos",
  "70d54252876996a817b5baa929b8eb74": "Respostas Automáticas",
  "54ee548bbbf04aca3ff627e8637b6e9a": "Ricardo Eletro ",
  bc1b195005f82de4e70dc41431c12282: "SAC",
  b2f0237ec6f53e2037fd9e0db637f64d: "Saraiva",
  "64b647388d34d5fb5d8e01a9b411c43e": "Shopfacil",
  f57430ab5e54dace7b04cae15ff53a9b: "Vtex Loja",
  "91dbdde41a4a3393fd4d781dbfe35f4d": "WalMart",
  ace8364d37494ae03da367fde88797f5: "WalMart V2",
  "5de98c314871a4f1970eb387e937db5c": "XtechCommerce",
  bde47c584bff465748476414cb6ba727: "Zoom MarketPlace",
  a04d2fc57682feb92c2453fe0f92e055: "Magento Plugg.To",
  e1f0f0d4c006a57b32b48ae14c35b3b0: "Enriquecedor de Dados",
  "8689600d46bc6f851edbeb794e84d017": "Magento - Pluggto - Teste ",
  c2fbd68743e449c99b205a491fd12173: "magentodev",
  "2de2f72c572619c34ae7020604667ead": "Magento Dev",
  "5a2ab8f9dc48e01c1bc35233fbf0ac59": "Loja 1",
  "6b0b5b58241d67917eb673d8c81d9e00": "MagentoDev",
  "1f01df429aea316f83b0464b95217f5d": "DevMagento",
  "84e3978afc4089ee5bffcb921a849e6d": "TIny - TESTE",
  "48ea7dc1aee5c89ef10bb5ab632eea6e": "magento-teste",
  "908e352eb7ab8c45d83d208c2cf419b9": "wBuy E-commerce - Homolog",
  e7b46199ffd26fdec9103d7b30352c51: "Opencart - Teste",

  //Applications q estavam faltando
  NTJhYTI3MTc4MDYyZjNk: "Painel",
  "788ceba032b67a0c12767667c09b24d3": "Opeco",
  "64c86d1fe6adf98602994e2bec41bfe5": "Cnova",
  "8dffd793fb3474b9d8e96b77d1765a8e": "b2w-local-teste",
  bc0661a61972734ce08811c6f3b5c3c0: "BlingDevLocal",
  e076f6a03691398773ed79c3e09aebaa: "Millenium",
  "1411557987c12efd8ee1da6bf481fde1": "CorreiosDev",
  "4ab7e66d63b4331b89df9366d365d1d5": "Novo Plugin de Teste",
  "5224f670b019ce61b0c8ad8d1d87d9a2": "VtexMkt",
  a2685d1d525c37ce3bbdd15d4ca68cca: "App de teste",
  "32b124b71880fe446b7ea40e9a24f531": "Loja Virtual",
  "1f57fb5127ee7060993a7b5b8e2ac8a7": "Sabrina",
  "14cd0770b0746009ba330b1d2eb23114": "Kanui",
  "860f7a809d8252f0536c6135aab2a4a6": "Gustavo ML",
  "5d614723ca4b002723489c67d026be96": "Dafiti Dev",
  "8f92e9052fda9ccf3dc6f465f4e52608": "Integração TOTVS",
  "2d6ce830051c99e5f784afebf8b92414": "Mercado Shops",
  "28e15d02a68d03ffbb0ebf3197fc7a85": "Nota Fiscal eletrônica",
  "4c1e304ddf32b203faaff73b71465964": "Tricae",
  c3a64c4e8a1240ccf467cd27e45bfc9e: "KPL ERP",
  b532220a1c1cb31636d8e69b8d7c3831: "Integracao-TOTVS",
  d56dfc41506867e565563b11e8a2ee00: "Emissor NFe",
  c140b4d8a2ff1f067139d132abad9fd8: "Emissor NFe 2.0",
  f992b89391c706fd3ffb2b52b619d314: "CiaShopDev",
  "63af8256cced7335f8d4ede9175a2352": "Mercado Livre Perguntas Gerenciador",
  "770b50e49ee1f0899e295e5d672a5479": "MeuAr",
  "22cf65484dea17d9c6d198910f13f3b0": "TMWxD",
  "417d68fecb9d6f2cfb2cce2e443682e1": "Vtex ERP",
  cce679d86cf6e51fdf82bc03bdef821f: "Vasculhei",
  a6e2b1f8e36e294ab4dbcd7852c4e53c: "Dafiti Argentina",
  f127421daedbe7b427f8b6b24648cad2: "Rede Mercosul",
  "2bce91642941339844cec01e1803abcf": "XML DEV",
  "2ffe66723c1431403cbb98a463d8e981": "Frenet",
  "220b16e9718ec487ad8653ba2554f143": "TMWxD-Decora",
  "4211b03272e07aa35f9292f5299a8bf1": "CaptarePRO",
  "9b80a0ddd78bd146d289987b8715a8da": "Marketplace Tiago",
  "01b176050c4dbb4eeb347dfa48d1366e": "Marketplace Felipe",
  "22a8e2f2d09d5801b4f4fd488049c54e": "Frete Rápido",
  a141063a618462e7482b87267829ba8d: "InfoAr",
  "4fbc841004d54d64c76870c478aafbdb": "Stoom",
  "4cfb7397a57dd15e20db8d14424a8a88": "shoppub",
  "0f6fc3f02a0792d6c599866ca6da60e7": "Integração cURL PHP Plugg.to via API",
  "2d1ef640f8e72c38fafd51f47849198e": "UoouCommerce",
  "032257a41e63392f239f1e26ec059faf": "TMWxD-Lojamatel",
  "4309dd5a97406d56ea077eb426abb718": "Integração com a Livelo",
  "7b98c37b915608c664ca5fe3fba26782": "Virtualskateshop",
  cc5771deee29d580af678ac98ccf7f75: "Virtualskateshop.com.br",
  d6a68e0affce349e1c05d25773b55e0c: "APP ERP Linx to Plugg.to",
  c8bce9aeda7bf8401594ffb309308e7a: "Mensageria",
  f02097761c9acc7bb24f335f14765183: "Myvillage Marketplace",
  dc3eb628ee1581c27a42f56dbbecf881: "Teste Fone Shop",
  f92756998ae69177db4bafee7110e94f: "rimo_market",
  cbda2d906cc84d50f473ca4169aa76cb: "Mobly-Gaya",
  ef278fc7472013f3204ccec7cb42bc6a: "TMWxD-PCPerformance",
  "9f8502dc364860c4a3b4601690c09b08": "Syncmoze",
  c0d399079eed33059c33d34ad9cea0fb: "OtimanutriAPI",
  ff67586a7d3eed262db3351f003000a3: "Manhattan Project",
  b259c24468f33149d40bbadefed0bd71: "Integração Plugae",
  fa80a6eec9842e0eebcc5e7d635e15d4: "System PD",
  "6f2682f98ecfdfc852935e37b53c1cde": "Notificações por Email",
  "7fb8a3c327fdefecc4f24df9f0d5a489": "SSPlus",
  "34a33bbdfdf0a244ef50f49046486e76": "RoupaShop",
  "26faaee569b0b2faf74864d4b2c5af42": "Integração Polihouse APP",
  "27b9889bf97b956e57da4d98da5b1f5e": "CoreV2",
  c6786d7c5365ec9831e3eea334b1d752: "Integração Exato Sistema",
  "7206d07797468b82d906a443e3245ca1": "Teste TI CCell",
  "14c3df43aee61c4c106e016bc3ff5df1": "CenterCell",
  "863f0415501c6a2ce689b4e9e5548614": "teste",
  f413868cfaa8c99ab65f5673a21a6880: "Integração EVG Plugg.to via API",
  cd7122a11dd83ee7b8aa0995ee602e20: "ERP_WHAL",
  "1d937a0ca36a5bff3b4fa3d113c72328": "Integração Cristina Fashion Brands",
  d0511a316e6689725d913a4bb63fa72a: "VitalCare MarketPlace",
  "114099569c9eaf57995531d5f8b852b8": "System LM",
  e572715c9c385b2b62728544d0582744: "SYSTEM MX",
  f45fb8d8a606a1fdc8d7c0d7c5942d26: "wBuy e-commerce",
  "70e7e447bf99c9ce843739e7a55bc1f7": "Toplojas",
  "3ba0b63743564833cf5a7bd13c31d25c": "teste_cc",
  "3ba0b63743564833cf5a7bd13c31d25c": "teste_ccas",
  "8e9258d1a0d7e923438750d6f3f784ea": "BrERP",
  "1119b5cabba83e38ec69367316ec9cb6": "aqx aplicação80",
  "0c1bb9fd7fae738ec8a19da24dcd8696": "aqx aplicação3232232",
  aa858b8f96a9651def9d5e2cdcdc5e19: "sadadsasdsadsadsa",
  "3b31f8fe8322c1e9816497dfb3f9f290": "sadadsasdsadsadsaxx",
  c7572fd2e2b1ffc3b5cea2a5d40373d6: "sadadsasdsadsadsaxx22",
  "57e1377edcf3b7c6bc62c4a70e64a84d": "saysasausuhashaus",
  d7aec26d9a63e97d0328df63c90c9ed6: "Vivara Teste",
  ddbdeb0e60f52c998d7d25d72c0000f0: "teste aplicaça",
  "158feb423d768adf6071466897b0b050": "Sinc Master",
  "3c022dfda592c772dfdcd1c75d56b853": "TrackCash",
  "5177f4501ad4b3f4f49a55aa470903bd": "Atena.ai",
  ff7d9cb152549fb4e05bb956909742a4: "NotaFiscal",
  "43da9b5c5bbaa80361057a9fdc89d872": "Setta",
  "64a9dede82f16b625f2336d9829e48a1": "Setta MarketPlace",

  //novos
  //Show Order
  "Razão Social": "Razão Social",
  Complemento: "Complemento",
  "Informações Adicionais": "Informações Adicionais",
  "Não encontramos nenhuma plataforma padrão configurada para a sua conta.":
    "Não encontramos nenhuma plataforma padrão configurada para a sua conta.",
  "status final": "status final",
  'Clique para mudar status do pedido para': 'Haga clic para cambiar el estado del pedido a',
  'Você tem certeza?': 'Are you sure?',
  'Erro': 'Error',
  'Não foi possível editar o status do pedido. Por favor, entre em contato com a PluggTo.': 'No se pudo editar el estado del pedido. Póngase en contacto con PluggTo.',
  "Você não possui permissão para editar pedidos.": "Usted no tiene permiso para editar pedidos.",

  //index
  "ID do Pedido": "",
  "Pendentes de Separação": "",
  //"Aguardando Faturar": "",
  picking: "Separação",
  waiting_picking: "Pendentes de separação",
  "Em Separação": "",
  processing_picking: "Em Separação",
  Separados: "",
  pending_invoice: "Separados",
  "Gerar nota fiscal": "",

  "Aguardando Nota Fiscal": "",
  waiting_invoice: "Aguardando Nota Fiscal",
  "Processando Pagamento Gnre": "",
  processing_invoice: "Aguardando Pagamento Gnre",
  "Aguardando Despacho": "",
  waiting_expedition: "Pronto para embalar",
  "Pronto para embalar": "",

  "Aguardando retirada": "",
  processing_expedition: "Aguardando retirada",
  "Despacho Incorreto": "",
  shipping_error: "Despacho Incorreto",
  "Em Transito": "",
  shipped: "Em Trânsito",
  delivered: "Entregue",
  "Integração Incorreta": "",
  "Mais filtros": "",

  //OrdersList
  Impressão: "",
  has_label: "Etiqueta",
  has_gnre_doc: "GNRE",
  has_invoice_doc: "NFE",
  "Ocorreu algum problema ao tentar gerar as etiquetas do pedido, tente novamente em alguns instantes.":
    "",
  "Etiquetas geradas com sucesso!": "",
  "Notas fiscais geradas com sucesso!": "",
  "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes.":
    "",
  "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes.":
    "",
  "GNREs geradas com sucesso!": "",
  "Disponível para impressão": "",
  Impresso: "",
  "Documento não gerado pelo sistema": "",

  //OrdersAction
  "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido para exportar":
    "",
  "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação":
    "",
  "Imprimir Lista de Picking": "",
  "Gerar nota fiscal": "",
  "O status do pedido foi alterado com sucesso!": "¡El estado del pedido se ha cambiado correctamente!",
  "Marcar como embalado": "",
  "Imprimir notas fiscais": "",
  "Imprimir tudo": "",
  "Imprimir GNRE": "",
  "Imprimir etiquetas": "",
  "Impressão de documentos": "",
  "Suas nostas fiscais e GNREs serão exportadas para um arquivo PDF e este arquivo será enviado para você assim que este processo estiver concluído.":
    "",
  "Dependendo da quantidade de pedidos que você tiver este processo pode demorar, por este motivo pedimos que você insira para qual e-mail deseja que o arquivo seja enviado assim que a exportação for concluída:":
    "",
  "Agendamento de exportação de documentos criado com sucesso, acompanhe o seu e-mail!":
    "",
  "Não foi possivel exportar os documentos.": "",
  "Nenhuma GNRE encontrada": "",
  "Nenhuma nota fiscal encontrada": "",
  "Marcar como enviado": "",
  "Todos os documentos disponíveis impressos com suceso!": "",
  "O pedido não contem o codigo de rastreio": "",
  Pedido: "",
  "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)": "",
  "É necessário enviar pelo menos um pedido.": "",
  "Não é possível gerar etiqueta na B2W para esse pedido": "",
  "O pedido não contem nome e/ou sobrenome do destinatário": "",
  "O pedido não contem endereço do destinatário": "",
  "O pedido não contem o bairro do destinatário": "",
  "O pedido não contem o cep do destinatário": "",
  "O pedido não contem a cidade do destinatário": "",
  "O pedido não contem o estado do destinatário": "",
  "O pedido não contem o codigo de rastreio": "",
  "O pedido não contem um serviço de postagem": "",
  "Enviar por SIGEP WEB": "",
  "Não foi possivel alterar o status dos pedidos com ID: ${ids}, tente novamente em alguns instantes.":
    "",
  "Não foi possivel alterar o método de envio, tente novamente em alguns instantes.":
    "",
  "Os pedidos foram alterados com sucesso!": "",
  "Metodo da Etiqueta": "",
  "Metodo de Envio": "",
  "É necessário configurar um formato de impressão para gerar as etiquetas": "",
  Clique: "",
  aqui: "",
  "para configurar o formato de impressão": "",
  "Ocorreu algum problema ao tentar gerar as etiquetas": "",
  "Lista de picking gerada com sucesso!": "",
  "Não foi possivel gerar a lista de picking, tente novamente em alguns instantes.":
    "",
  "Não foi possivel alterar o status dos pedido tente novamente em alguns instantes.":
    "",
  manual: "manual",
  third_contract: "contrato de terceiro",
  "fulfillment": "fulfillment",
  own_contract: "contrato proprio",
  pickup_store: "entrega pela loja",
  drop_shipping: "entrega pelo fornecedor",
  fulfillment: "fulfillment",
  "Dados de pagamento": "",
  "Não recebemos dados de pagamento de nenhum marketplace": "",
  "Filtros Aplicados": "",
  "Número de parcelas":"",
  "Carregar novos pedidos": "Cargar nuevos pedidos",
  "credit_card": "Tarjeta de Crédito",
  "CreditCard": "Tarjeta de Crédito",
  "Credit Card": "Tarjeta de Crédito",
  "visa": "Visa",
  "master": "Mastercard",
  "account_money": "Dinero en Cuenta",
  "Pix": "Pix",
  "pix": "Pix",
  "amex": "American Express",
  "SParcelado": "Pago Fraccionado",
  "consumer_credits": "Créditos al Consumidor",
  "installments": "Cuotas",
  "elo": "Elo",
  "GiftCertificate": "Certificado de Regalo",
  "Boleto": "Menudillo",
  'Pedidos onde a forma de entrega é “a combinar”': 'Pedidos en los que la forma de entrega sea "a convenir"',
  "Todos os pedidos que já podem ser separados, nessa fase poderá imprimir a lista se preferir.": "Todos los pedidos que ya se pueden separar, en esta etapa puedes imprimir la lista si lo prefieres.",
  "Aqui encontram-se os pedidos em processo de separação no estoque.": "Aquí están los pedidos en proceso de picking en stock.",
  "Todos os pedidos que já tiveram os seus itens separados no estoque.": "Todos los pedidos que ya han tenido sus artículos seleccionados en stock.",
  "Pedidos que ainda precisam gerar a nota fiscal.": "Pedidos que aún necesitan generar la factura.",
  "Se o pedido está aqui, significa que ocorreu algum problema com a geração automática da nota fiscal do seu pedido." : "Si el pedido está aquí, significa que hubo un problema con la generación automática de la factura de su pedido.",
  "A etiqueta para os determinados pedidos ainda não estão disponíveis." : "La etiqueta para ciertos pedidos aún no está disponible.",
  "Todos os pedidos aqui encontram-se prontos para serem embalados." : "Todos los pedidos aquí están listos para ser empaquetados.",
  "Tudo certo, pedido tá pronto para ser retirado.": "Muy bien, la orden está lista para ser retirada.",
  "Os pedidos estão a caminho dos seus destinos.": "Los pedidos están en camino a sus destinos.",
  "Todos os pedidos que já foram entregues, por aqui tá tudo certo.": "Todos los pedidos que ya han sido entregados, todo está bien aquí."
};



// WEBPACK FOOTER //
// ./resources/assets/js/languages/AR.js